<template>
  <div class="main">
    <div class="logo "></div>
    <input
      id="mobile"
      type="text"
      placeholder="登录手机号"
      v-model="loginParams.mobile"
    />
    <input
      id="psw"
      type="password"
      placeholder="密码"
      v-model="loginParams.pwd"
    />
    <div
      class="row-code"
      v-if="loginCode"
    >
      <input
        id="code"
        class="lg-in-code"
        type="text"
        placeholder="验证码"
        v-model="loginParams.v_code"
      />
      <img
        id="codeImg"
        :src="codeImg"
        alt="验证码"
        @click="changeCodeImg"
      />
    </div>
    <div class="tips">{{tips}}</div>
    <div
      class="btn-submit"
      @click="login"
    >登录</div>
    <!-- <a class="forget-psd" @click="goRevisePwd">忘记密码</a> -->
    <a
      class="reg"
      @click="goRegistUser"
    >立即注册</a>
  </div>
</template>

<script>
import { login, getuserinfo } from './../axios/api'
// 线上环境
const loginCodeImg = 'http://mpserver.tt.cn/east-usercenter/util/getVerifyImgCode'
// 测试环境
// const loginCodeImg = 'http://tt.mp.eastday.com:8581/mauthimage'
export default {
  name: 'Login',
  data() {
    return {
      loginCode: true,
      codeImg: '',
      loginParams: {
        mobile: '',
        pwd: '',
        v_code: '',
        sign: 1
      },
      tips: '',
      judgeRule: [
        {
          ele: 'mobile',
          func: function(val) {
            let ifm = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1}))+\d{8})$/.test(val);
            return ifm;
          },
          error: '请输入正确的手机号'
        },
        {
          ele: 'pwd',
          func: function(val) {
            // let reg = /^(?=.*[a-zA-Z])(?=.*\d)[~!@#$%^&*()_+`\-={}:";'<>?,.\/\w]{4,16}$/;
            let reg = /^[^\u4e00-\u9fa5]{4,16}$/;
            let ifm = reg.test(val);
            return ifm;
          },
          error: '请输入正确格式的密码！'
        }
      ]
    }
  },
  mounted() {
    this.codeImg = loginCodeImg + '?account=' + this.loginParams.mobile + '&status=' + Math.random();
  },
  methods: {
    goRegistUser() {
      this.$router.push({ path: '/RegistUser' })
    },
    goRevisePwd() {
      this.$router.push({ path: '/RevisePwd' })
    },
    checkAll(params) {
      let that = this;
      let ifok = this.judgeRule.every(function(item) {
        let ele = item.ele;
        let func = item.func;
        let ifm = func(params[ele]);
        let error = item.error;

        if (ifm) {
          that.tips = '';
        } else {
          that.tips = error;
        }
        return ifm;
      });
      return ifok;
    },
    changeCodeImg() {
      //  this.codeImg = loginCodeImg+"?r="+Math.random();
      this.codeImg = loginCodeImg + '?account=' + this.loginParams.mobile + '&status=' + Math.random();
    },
    login() {
      let params = this.loginParams;
      if (!this.checkAll(params)) {
        return false;
      }
      let that = this;
      login(params).then(result => {
        if (result.code == '0') {
          if (result.data) {
            localStorage.setItem('accountPhone', result.data.mobile);
          }
          if (result.data.registstep == 3) {
            that.$router.push({ path: '/Homepage' });
          } else if (result.data.registstep == 1) {
            that.$router.push({ path: '/RegistType' });
          } else if (result.data.registstep == 2 && result.data.entryType == 1) {
            that.$router.push({ path: '/registData' });
          } else {
            alert('请先完成注册')
          }
        } else if (result.code == 114 || result.code == 22) {
          that.loginCode = true;
          //    that.codeImg = loginCodeImg+"?r="+Math.random();
          that.codeImg = loginCodeImg + '?account=' + this.loginParams.mobile + '&status=' + Math.random();
        } else {
          this.$layer.dialog({
            content: result.msg,
            time: 3000
          })
          //   alert(result.msg)
        }
        // console.log(result)
        // if(result.auth=="true"){
        //     that.loginCode = true;
        //     that.codeImg = loginCodeImg+"?r="+Math.random();
        // }
        // else if(result.auth=="false"){
        //     that.loginCode = false;
        // }
        // // 登陆失败
        // if(result.stat!=1){
        //     that.tips = result.msg;
        //     return false;
        // }
        // else{ // 登陆成功
        //     that.getuserinfo();
        // }
      })
    },
    getuserinfo() {
      let that = this;
      getuserinfo().then(result => {
        if (result.stat != 1) { // 需要跳转到登陆页面
          alert('登录失败！')
          that.$router.push({ path: '/Login' });
        } else {
          if (result.user) {
            if (result.user.registstep == 3) { // 有入驻资料,类型选择页面跳首页
              that.$router.push({ path: '/Homepage' });
            } else {
              that.$router.push({ path: '/RegistType' });
            }
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.main {
  min-height: 100%;
  background: #fff;
  position: relative;
  font-size: 0.24rem;
}
.main .logo {
  width: 2.28rem;
  height: 2.28rem;
  background: url("./../assets/img/logo.png") no-repeat;
  background-size: cover;
  margin: 1.5rem auto 0;
}
.main .logo.top-margin {
  margin: 1rem auto 0;
}
.btn-submit,
input {
  display: block;
  width: 5rem;
  height: 0.9rem;
  border-radius: 0.9rem;
  font-size: 0.36rem;
  text-align: center;
  color: #333333;
  border: 1px solid #bababa;
}
input:focus {
  border: 1px solid #f96d6d;
}
input::-webkit-input-placeholder {
  color: #999;
}
#mobile {
  margin: 1.45rem auto 0;
}
#psw {
  margin: 0.38rem auto 0;
}
.tips {
  width: 5rem;
  font-size: 0.24rem;
  color: #ff4153;
  text-align: center;
  margin: 10px auto 0;
  line-height: 0.5rem;
}
.btn-submit {
  background: #f84e4e;
  color: #fff;
  margin: 0.5rem auto 0;
  border: 0;
  line-height: 0.9rem;
}
.forget-psd,
.reg {
  width: 3rem;
  height: 0.8rem;
  text-align: center;
  line-height: 0.8rem;
  color: #b3b3b3;
  font-size: 0.3rem;
  display: block;
  border-bottom: 1px solid #f1f1f1;
  margin: 0 auto;
}
.forget-psd {
  margin-top: 0.6rem;
}
.row-code {
  width: 5rem;
  height: 0.9rem;
  margin: 0.38rem auto 0;
}
.row-code input {
  width: 3rem;
  height: 0.9rem;
  float: left;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-right: 0;
}
.row-code img {
  float: left;
  width: 2rem;
  height: 0.9rem;
  border-bottom-right-radius: 0.9rem;
  border-top-right-radius: 0.9rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue